module.exports = __webpack_public_path__ + "img/zyrz.0ea6dd55.png";